export default __webpack_public_path__ + "static/media/WAS0390.34I-39721_-23580_0.cb6fa6fa.jpg";